export enum EChartEvent
{
    OnChartInitializationError = 1,
    OnChartInitialized,
}